export const emailPattern = "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[a-zA-Z0-9-.]+$";
export const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9]+\.([A-Za-z]).{1,}$/;

export const passwordPattern =
  /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/;

export const maxDate = new Date().toISOString().split("T")[0];
